// SPDX-License-Identifier: AGPL-3.0-or-later

import {getElectronAPI, isDesktop} from '@app/features/ui/utils/NativeUtils';

export function quickCssEditorNeedsDesktopUpdate(): boolean {
	return isDesktop() && getElectronAPI()?.cssEditorWindow !== true;
}
